import React, {useState} from 'react';
import SimpleConfirmationDialog from "./SimpleConfirmationDialog";
import {DialogContentText, Typography} from "@mui/material";
import {removeAccountFundingSource} from "./user/request/user-requests";
import Busy from "./Busy";
import {getErrorMessageForNonStandardAndStandardResponse} from "../util/NetworkErrorUtil";
import {styled} from "@mui/material/styles";

const MarginTop10 = styled(Typography)(() => ({
  marginTop: '0.71rem',
}));

const DialogBody = ({errorMsg}) => {
  return <>
    <DialogContentText component={'strong'}>
      Are you sure you would like to remove this payout account? Please make sure to replace or update your bank
      account on file in order to process any payout from Securspace going forward.
    </DialogContentText>
    {
      errorMsg &&
      <MarginTop10 variant="body1" component="div" color="error" align="center">
        {errorMsg}
      </MarginTop10>
    }
  </>
}

const RemovePartnerFundingSourceDialog = (props) => {
  const {account, open, onClose, onSuccess} = props;
  const [errorMsg, setErrorMsg] = useState('');

  const resetDialog = () => {
    setErrorMsg('');
  }

  const handleClose = () => {
    resetDialog();
    onClose();
  };

  const handleConfirm = (event) => {
    event.preventDefault();
    const handleSuccess = (response) => {
      Busy.set(false);
      resetDialog();
      onSuccess(response);
    };
    const handleError = (error) => {
      Busy.set(false);
      setErrorMsg(getErrorMessageForNonStandardAndStandardResponse(error));
    };
    Busy.set(true);
    removeAccountFundingSource(account.id, handleSuccess, handleError);
  };

  return (
    <SimpleConfirmationDialog
      onClose={handleClose}
      onConfirm={handleConfirm}
      open={open}
      title="Remove Payout Account"
      body={<DialogBody errorMsg={errorMsg}/>}
    />
  );
};

export default RemovePartnerFundingSourceDialog;
